module.exports = __webpack_public_path__ + "static/media/brazilianJiuJitsu-class-1.a64cc4e8.jpeg";